import { render, staticRenderFns } from "./EvaluationSubmitsTable.vue?vue&type=template&id=db184d7a&scoped=true&"
import script from "./EvaluationSubmitsTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationSubmitsTable.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationSubmitsTable.vue?vue&type=style&index=0&id=db184d7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db184d7a",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BButton, BTable} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BButton, BTable})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBPopover} from 'bootstrap-vue'
    installDirectives(component, {'b-popover': VBPopover})
    

export default component.exports